export default {
  callBackApi: {
    getNeedCallBack: 'api/callBackApi/getNeedCallBack',
    uploadConsultantInfo: 'api/callBackApi/uploadConsultantInfo',
    getCallBackLedger: 'api/callBackApi/getCallBackLedger',
    distribution: {
      distributionPageList: 'api/callBackDistributionApi/distributionPageList',
      consultationPageList: 'api/callBackDistributionApi/consultationPageList',
      getCallbackUsers: 'api/callBackDistributionApi/getCallbackUsers',
      addDistributionRecord: 'api/callBackDistributionApi/addDistributionRecord',
      cancelDistribution: 'api/callBackDistributionApi/cancelDistribution',
    },
    gauging: {
      // 回访员回访
      gaugingPageList: 'api/callbackGaugingApi/gaugingPageList',
      gaugingResult: 'api/callbackGaugingApi/gaugingResult',
      modifyResult: 'api/callbackGaugingApi/modifyResult',
      getGauging: 'api/callbackGaugingApi/getGauging',
      getGaugingPhone: 'api/callbackGaugingApi/getGaugingPhone',

    },
    result: {
      // 回访结果
      resultPageList: 'api/callbackResultApi/resultPageList',
      getConsultationResult: 'api/callbackResultApi/getConsultationResult',
      exportData: 'api/callbackResultApi/exportResultData',
      exportResultDataAll: 'api/callbackResultApi/exportResultDataAll',
      exportResultDataByDistribution: 'api/callbackResultApi/exportResultDataByDistribution'
    }

  }
}
